import { render } from "./ProfileImage.vue?vue&type=template&id=131783f8&lang=true"
import script from "./ProfileImage.vue?vue&type=script&lang=js"
export * from "./ProfileImage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__